import { useApprovalConfig } from './useApprovalConfig';
import { useApprovalData } from './useApprovalData';
import { useApprovalMeta } from './useApprovalMeta';
import { useApprovalSkipConfig } from './useApprovalSkipConfig';
export const useApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  assetName,
  approvalObjectIds,
  previewSidebarContent,
  restartOnConclude
}) => {
  const approvalConfig = useApprovalConfig(approvalType, approvalAction);
  const approvalData = useApprovalData(approvalType, approvalAction, approvableObjectId, assetName, approvalObjectIds);
  const approvalSkipConfig = useApprovalSkipConfig(approvalAction, approvalType);
  const api = Object.assign({
    fetchConfig: approvalConfig.fetchConfig,
    fetchSkipConfig: approvalSkipConfig.fetchSkipConfig
  }, approvalData.api);
  const meta = useApprovalMeta({
    approvalType,
    approvalAction,
    approvableObjectId,
    assetName,
    approvalObjectIds,
    previewSidebarContent,
    restartOnConclude,
    approvalData,
    approvalConfig,
    approvalSkipConfig
  });
  return {
    api,
    data: approvalData.data,
    config: approvalConfig.config,
    meta,
    skipConfig: approvalSkipConfig.skipConfig,
    previewSidebarContent
  };
};